import { createStore, applyMiddleware } from 'redux';
import rootReducer from './rootReducer';
import apiMiddleware from "../middleware/apiMiddleware";

const store = createStore(rootReducer, applyMiddleware(apiMiddleware));

export default store;